import { render, staticRenderFns } from "./RoutestopEdit.vue?vue&type=template&id=67608f1e"
import script from "./RoutestopEdit.vue?vue&type=script&lang=js"
export * from "./RoutestopEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports